(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["purple-discs-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // ===== SMOOTH SCROLL for all anchor links =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== TOAST HELPER =====
  function showToast(msg, isError) {
    var toast = document.getElementById('pd-toast');
    toast.textContent = msg;
    toast.className = 'pd-toast pd-toast--show' + (isError ? ' pd-toast--error' : '');
    setTimeout(function() {
      toast.className = 'pd-toast';
    }, 3500);
  }

  // ===== ADD TO CART + DISCOUNT AUTO-APPLY =====
  // 
  // HOW IT WORKS:
  // 1. POST /cart/add.js  → product variant cart mein add hota hai
  // 2. POST /cart/update.js → discount code apply hota hai (Shopify cart attributes)
  // 3. Redirect /checkout?discount=CODE → checkout pe code auto-fill hota hai
  //
  // NOTE: Shopify mein discount code cart level pe directly apply nahi hota JS se.
  // Sabse reliable method hai checkout URL mein code pass karna.

  document.querySelectorAll('.pd-add-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var variantId = this.dataset.variantId;
      var discountCode = (this.dataset.discount || '').trim();

      // Fallback: agar data-discount blank ho to card par dikhne wala coupon code use karo
      if (!discountCode) {
        var card = this.closest('.pd-product-card');
        var codeEl = card ? card.querySelector('.couponcode b') : null;
        if (codeEl) discountCode = codeEl.textContent.trim();
      }

      // Variant ID check
      if (!variantId || variantId === '') {
        showToast('Product variant ID missing. Please check Shopify settings.', true);
        return;
      }

      // Button disable karo loading ke time
      var originalText = this.textContent;
      this.disabled = true;
      this.textContent = 'Adding...';

      var self = this;

      // Step 1: Cart mein add karo
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function(data) {
        showToast('Added! Redirecting to checkout...', false);

        // Step 2: Redirect to checkout with discount code in URL
        // Shopify automatically applies the discount at checkout
        setTimeout(function() {
          if (discountCode && discountCode !== '') {
            var checkoutUrl = '/checkout?discount=' + encodeURIComponent(discountCode);
            // Pehle /discount/CODE hit karo taaki code session mein save ho jaye, phir checkout
            fetch('/discount/' + encodeURIComponent(discountCode), { credentials: 'same-origin' })
              .catch(function() {})
              .then(function() { window.location.href = checkoutUrl; });
          } else {
            window.location.href = '/checkout';
          }
        }, 1200);
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        showToast('Something went wrong. Please try again.', true);
        self.disabled = false;
        self.textContent = originalText;
      });
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
